import { useContext } from 'react';
import { CalendarContext } from '../CalendarProvider';
function useCalendar() {
  return useContext(CalendarContext);
}
export default useCalendar;